<template>
    <div
        :class="{
            'catalog-of-description': true,
            'catalog-of-description--deformable': deformable
        }"
        @mouseenter="handleMouseenter"
        @mouseleave="handleMouseleave"
    >
        <div
            v-for="catalog in catalogs"
            :key="catalog.title"
            :title="catalog.title"
            :style="{
                height: `calc(100% * ${1 / catalogs.length})`
            }"
            :class="{
                'catalog-of-description-item': true,
                'catalog-of-description-item--active': catalog.category_id === structureCategory.id
            }"
            @click="setDescPosition(catalog.category_id)"
        />
        <div
            v-show="popperVisible"
            class="catalog-of-description-popper"
            :class="{
                'catalog-of-description-popper--has-scrollbar': scrollbarWidth
            }"
        >
            <div
                v-for="catalog in catalogs"
                :key="catalog.title"
                :class="{
                    'catalog-of-description-popper-item': true,
                    'catalog-of-description-popper-item--active': catalog.category_id === structureCategory.id,
                    'catalog-of-description-popper-item--main': isFulltext && fullTextIdMap.includes(catalog.category_id),
                    'catalog-of-description-popper-item--sub': isFulltext && !fullTextIdMap.includes(catalog.category_id)
                }"
                @click="setDescPosition(catalog.category_id)"
            >
                {{ catalog.title }}
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import { SELECTOR_APP_CONTENT_VIEW } from '../../constants';

/**
 * https://www.coder.work/article/4240999
 */
function getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

export default {
    name: 'CatalogOfDescription',
    props: {
        catalogs: {
            type: Array,
            default() {
                return [];
            },
        },
        /**
         * 可变形的
         */
        deformable: {
            type: Boolean,
            default: false,
        },
        isFulltext: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            structureCategory: {
                id: '',
                needScroll: false,
            },
            popperVisible: false,
        };
    },
    computed: {
        inSingleView() {
            return !!this.$route.meta.pluginName;
        },
        fullTextIdMap() {
            return this.isFulltext ? ['abst', 'clms', 'desc'] : [];
        },
    },
    watch: {
        structureCategory() {
            if (this.structureCategory.needScroll) {
                const stDom = this.$$scrollContainer.find(`.structure_${this.structureCategory.id}`)[0];
                if (!stDom) return;
                const text = stDom.textContent;
                /**
                 * 当开启compare -> 相似段落时，会改变原本的dom结构，所以直接使用stDom 获取 offsetTop不准确
                 * 因此直接使用其外层的段落节点div[p](如果有)来获取offsetTop
                 */
                const stParentsDom = $(stDom).parents('[p]')[0];
                let scrollTop = (this.isFulltext || !stParentsDom ? stDom.offsetTop : stParentsDom.offsetTop)
                    + ((this.fullTextIdMap.includes(this.structureCategory.id) || !this.isFulltext) ? 0 : $('.patent-app-view__fullText .desc-render')[0].offsetTop);
                if (!text && scrollTop > 20) {
                    scrollTop -= 20;
                }
                this.isScrolling = true;
                const selectorScrollContainer = this.$route.meta.pluginName
                    ? SELECTOR_APP_CONTENT_VIEW
                    : '.highlight-box';
                $(this.$el)
                    .siblings(selectorScrollContainer)
                    .stop()
                    .animate(
                        {
                            scrollTop: `${scrollTop}px`,
                        },
                        200,
                        () => {
                            this.isScrolling = false;
                        },
                    );
            }
        },
        catalogs(value) {
            if (value) {
                this.setDescPosition();
            }
        },
    },
    created() {
        this.scrollHandlerDebounce = _.debounce(this.scrollHandler, 50);
        this.scrollbarWidth = !!getScrollbarWidth();
    },
    mounted() {
        this.$$el = $(this.$el);
        /* 根据单双视图确定滚动容器 */
        const selectorScrollContainer = this.inSingleView ? SELECTOR_APP_CONTENT_VIEW : '.content-box';
        this.$$scrollContainer = this.$$el.parents(selectorScrollContainer);
        /* 根据单双视图确定挂载点 */
        const selectorMountPoint = this.inSingleView ? '.ps-single-view' : '.ps-side-view';
        this.$$mountPoint = this.$$el.parents(selectorMountPoint);
        this.$$mountPoint.append(this.$$el);
        this.enableScroll();

        this.setDescPosition();
    },
    beforeDestroy() {
        $(this.$el).remove();
        this.disableScroll();
    },
    methods: {
        handleMouseenter() {
            clearTimeout(this.it);
            this.popperVisible = true;
        },
        handleMouseleave() {
            this.it = setTimeout(() => {
                this.popperVisible = false;
            }, 500);
        },
        scrollHandler() {
            if (this.isScrolling) return;
            const scrollTop = this.$$scrollContainer.scrollTop();
            let nearestIndex = -1;
            let minValue = 1000000; //默认给一个较大的数值用于后面比较
            const descTitleDom = this.$$scrollContainer.find('.desc-title');
            descTitleDom.each(item => {
                const matchedId = $(descTitleDom[item]).attr('data-id');
                const descTitleParentsDom = $(descTitleDom[item]).parents('[p]')[0];
                const offsetTop = (this.isFulltext || !descTitleParentsDom ? descTitleDom[item].offsetTop : descTitleParentsDom.offsetTop)
                    + ((this.fullTextIdMap.includes(matchedId) || !this.isFulltext) ? 0 : $('.patent-app-view__fullText .desc-render')[0].offsetTop);
                const tempVal = Math.abs(offsetTop - scrollTop);
                if (tempVal < minValue) {
                    minValue = tempVal;
                    nearestIndex = item;
                }
            });
            if (nearestIndex === -1) return;
            const id = descTitleDom.eq(nearestIndex).attr('data-id');
            this.structureCategory.id = id;
        },
        setDescPosition(id) {
            if (this.catalogs.length > 0) {
                this.structureCategory = {
                    id: this.catalogs[0].category_id,
                    needScroll: false,
                };
            }
            if (id) {
                this.structureCategory = { id: id, needScroll: true };
                window.rvTrack('Click StructureLink In Desc', { type: id });
            }
        },
        enableScroll() {
            this.$$scrollContainer.on('scroll', this.scrollHandlerDebounce);
        },
        disableScroll() {
            this.$$scrollContainer.off('scroll', this.scrollHandlerDebounce);
        },
    },
};
</script>

<style lang="scss">
.catalog-of-description {
    position: absolute;
    right: 18px + 15px + 4px; /* .density-bar@right + .density-bar@width + gap */
    bottom: 16px;
    height: 200px;
    width: 4px;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    margin: 0 6px;
    background-color: $neutral-blue-40;
    &-item {
        flex: 1;
        width: 4px;
        background-color: $neutral-blue-40;
        cursor: pointer;
        border-radius: 2px;
        &:hover {
            background-color: $neutral-blue-60;
        }
        &--active {
            background-color: $green !important;
        }
    }
    &-popper {
        &::before {
            content: '';
            position: absolute;
            display: block;
            height: 100%;
            width: 6px;
            top: 0px;
            right: -7px;
        }
        opacity: 0.95;
        cursor: pointer;
        position: absolute;
        right: 10px;
        bottom: 0;
        width: 240px;
        background: $white;
        border: 1px solid $neutral-blue-30;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        padding: 12px;
        &-item {
            padding-left: 10px;
            cursor: pointer;
            position: relative;
            line-height: 16px;
            font-size: 14px;
            &:not(:last-child) {
                margin-bottom: 16px;
                &::after {
                    content: '';
                    width: 1px;
                    height: calc(100% + 16px);
                    line-height: 16px;
                    display: block;
                    background-color: $neutral-blue-60;
                    position: absolute;
                    left: -1px;
                    top: 8px;
                }
            }
            color: $text-light-blue;
            &:hover {
                color: $text-dark-blue;
            }
            &::before {
                content: '';
                border: 1px solid $neutral-blue-60;
                border-radius: 50%;
                background-color: $white;
                display: block;
                top: 4px;
                left: -5px;
                width: 9px;
                height: 9px;
                position: absolute;
                z-index: 9;
            }

            &--active {
                color: #1d8820;
                &::before {
                    content: '';
                    border: 1px solid $green;
                    background-color: $green;
                    display: block;
                }
            }
            &--sub {
                padding-left: 26px;
            }
            &--main {
                font-weight: bold;
            }
        }
    }
}

/* 单视图下的定位 */
.ps-single-view {
    .desc-render.has-catalogs {
        @media (min-width: 1439.5px) {
            padding-right: 136px;
        }
    }
}

.catalog-of-description--deformable {
    @media (min-width: 1439.5px) {
        width: 0;
        margin: 0;
        .catalog-of-description-item {
            display: none;
        }
        .catalog-of-description-popper {
            display: block !important;
            border: none;
            box-shadow: none;
            padding: 0;
            margin: 0;
            width: 130px;
            right: 0;
            bottom: 40px;
            opacity: 0.95;
            &.catalog-of-description-popper--has-scrollbar {
                width: 146px;
            }
        }
    }
}
</style>
